import { Container, Row, Col, Button, Form, FormGroup, Input, Label } from 'reactstrap';
import Multiselect from 'multiselect-react-dropdown';
import Link from 'next/link';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCookie } from 'cookies-next';
import axios from "axios";
import { AgencyRoleId } from '../../lib/Common';
import GoogleModal from '../../components/public/GoogleMap/GoogleModal';
import PublicLayout from '../../components/layouts/PublicLayout';
import Head from 'next/head';

const AgencySignup = ({ data, categories, meta }) => {

    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedSubCategories, setSelectedSubCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [showSubCategorySelect, setShowSubCategorySelect] = useState(false);
    const [businessName, setBusinessName] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [roleId, setRoleId] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const router = useRouter();
    // const [meta, setMeta] = useState('');

    const [firstNameErr, setFirstNameErr] = useState('');
    const [lastNameErr, setLastNameErr] = useState('');
    const [emailErr, setEmailErr] = useState('');
    const [phoneErr, setPhoneErr] = useState('');
    const [businessNameErr, setBusinessNameErr] = useState('');
    const [categoryErr, setCategoryErr] = useState('');
    const [subCategoryErr, setSubCategoryErr] = useState('');
    const [postalCodeErr, setPostalCodeErr] = useState('');
    const [otherError, setOtherError] = useState('');

    useEffect(() => {
        if(data) {
            let prefix = '';
            if(data.role_id === 1) {
                prefix = process.env.NEXT_PUBLIC_ADMIN_ROUTE;

            } else if(data.role_id === 2){
                prefix = process.env.NEXT_PUBLIC_AGENCY_ROUTE;
            }

            router.push({pathname: '/'+ prefix + '/dashboard'})
        }
        setRoleId(AgencyRoleId);

    }, [data, router, AgencyRoleId]);

    useEffect(() => {
        let categoriesIds = [];
        for (let i = 0; i < selectedCategories.length; i++) {
            categoriesIds.push(selectedCategories[i].id);
        }
        if(categoriesIds.length) {
            axios.get(process.env.NEXT_PUBLIC_API_URL + 'all_technologies?category_ids='+categoriesIds, { 
                headers: { "Accept": "application/json" }

            }).then(res => {
                setSubCategories(res.data.data);
                setShowSubCategorySelect(true);

                if(selectedSubCategories.length) {
                    let data = [];
                    for (let i = 0; i < selectedSubCategories.length; i++) {
                        data.push(selectedSubCategories[i].id);
                    }
                    if(data.length) {
                        let subCategory = subCategories.map((dd) => {
                            if(data.includes(dd.id)) {
                                return {
                                    name:dd.attributes.name, id:dd.id
                                }
                            }
                        });
        
                        if(subCategory.length) {
                            subCategory = subCategory.filter((element) => element !== undefined);
                            setSelectedSubCategories(subCategory)
                        }
                    }
                }

            },(error) => {
                console.log(error.response);
            });
        } else {
            setSubCategories([]);
            setShowSubCategorySelect(false);
        }

    }, [selectedCategories]);

    useEffect(() => {
        if(selectedSubCategories.length) {
            let data = [];
            for (let i = 0; i < selectedSubCategories.length; i++) {
                data.push(selectedSubCategories[i].id);
            }
            if(data.length) {
                let subCategory = subCategories.map((dd) => {
                    if(data.includes(dd.id)) {
                        return {
                            name:dd.attributes.name, id:dd.id
                        }
                    }
                });

                if(subCategory.length) {
                    subCategory = subCategory.filter((element) => element !== undefined);
                    setSelectedSubCategories(subCategory)
                }
            }
        }

    }, [selectedSubCategories]);

    const handler = (data) => {
		if(data.postal_code) {
            setPostalCode(data.postal_code);
            setPostalCodeErr('');
		}
	}

    const onChangeInput = (e) => {
        let value = e.target.value;

        switch(e.target.name) {
            case 'first_name':
                setFirstName(value);
                setFirstNameErr('');
                break;
            case 'last_name':
                setLastName(value);
                setLastNameErr('');
                break;
            case 'business_name':
                setBusinessName(value);
                setBusinessNameErr('');
                break;
            case 'email':
                setEmail(value);
                setEmailErr('');
                break;
            case 'postal_code':
                setPostalCode(value);
                setPostalCodeErr('');
                break;
            case 'phone_no':
                setPhoneNo(value);
                setPhoneErr('');
                break;
            default:
        }
	}

    const resetForm = () => {
        setFirstNameErr(''); setLastNameErr(''); setCategoryErr('');
        setEmailErr(''); setPhoneErr(''); setBusinessNameErr('');
        setPostalCodeErr(''); setOtherError(''); setBusinessName('');
        setPostalCode(''); setPhoneNo(''); setFirstName('');
        setLastName(''); setEmail(''); setSelectedCategories([]);
        setShowSubCategorySelect(false); setSelectedSubCategories([]);
        setSubCategories([]);
    }

    const submitHandler = (e) => {
        if(!loading) {

			setLoading(true)
			e.preventDefault();

			let formData = new FormData();
			formData.append('first_name', firstName);
			formData.append('last_name', lastName);
			formData.append('role_id', roleId);
			formData.append('email', email);
			formData.append('business_name', businessName);
			formData.append('postal_code', postalCode);
			formData.append('phone_no', phoneNo);

			if(selectedCategories.length) {
	            for (let i = 0; i < selectedCategories.length; i++) {
	                formData.append(`category_ids[${i}]`, selectedCategories[i].id)
	            }
	        }

	        if(selectedSubCategories.length) {
	            for (let i = 0; i < selectedSubCategories.length; i++) {
	                formData.append(`sub_category_ids[${i}]`, selectedSubCategories[i].id)
	            }
	        }

			axios.post(process.env.NEXT_PUBLIC_API_URL+'register', formData, { headers: {
				'Content-Type': 'multipart/form-data',  "Accept": "application/json" }
			})
			.then((response) => {
				setLoading(false); resetForm();
                console.log(response);
                router.push({
                    pathname: '/' + process.env.NEXT_PUBLIC_AGENCY_ROUTE + '/details',
                    query: response.data.data
                });

				// this.props.history.push({
				// 	pathname: process.env.REACT_APP_AGENCY_ROUTE+ "/details",
				// 	state: ,
				// 	props: this.props.location.state,
				// })
			},
			(error) => {
				e.preventDefault();
                setLoading(false);

				if(error.response.status === 412) {
					setFirstNameErr(error.response.data.validation_error.first_name);
                    setLastNameErr(error.response.data.validation_error.last_name);
                    setEmailErr(error.response.data.validation_error.email);
                    setPhoneErr(error.response.data.validation_error.phone_no);
                    setBusinessNameErr(error.response.data.validation_error.business_name);
                    setCategoryErr(error.response.data.validation_error.category_ids);
                    setSubCategoryErr(error.response.data.validation_error.sub_category_ids);
                    setPostalCodeErr(error.response.data.validation_error.postal_code);

				} else {
					setOtherError(error.response.data.message);
				}

			});
		}
    }

    const subCategoryList = () => {
        return (subCategories.map(data =>({name:data.attributes.name, id:data.id})))
    }

    const onSelectCategory = (selectedList) => {
        setSelectedCategories(selectedList);
        setShowSubCategorySelect(true);
	}

    const onRemoveCategory = (selectedList) => {
        setSelectedCategories(selectedList);
        setShowSubCategorySelect(true);
	}

    const onSelectSubCategory = (selectedList) => {
        setSelectedSubCategories(selectedList);
	}

	const onRemoveSubCategory = (selectedList) => {
        setSelectedSubCategories(selectedList);
	}

    return (
        <div className="signup_1_section" id="agency-signup">
        <Head>
            <meta name="keywords" content={meta ? meta.keywords : ''} />
            <title>{meta ? meta.title : ''}</title>
            <meta name="description" content={meta ? meta.description : ''} />
            <link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
        </Head>
            <Container fluid="xl">
                <Row>
                    <Col lg="5" xl="4" md="6">
                        <div className="form_Section ">
                            <h1 className="main-heading">Get Started Now</h1>
                            <h3 className="signup_title">Basic Info</h3>
                            <Form>
                                <FormGroup>
                                    <Input
                                        type="text"
                                        name="business_name"
                                        value={businessName}
                                        onChange={onChangeInput}
                                        placeholder="Your Business Name"
                                        className="input_text"/>
                                        <span className="errorMsg">{businessNameErr}</span>
                                </FormGroup>
                                <FormGroup>
                                    <Multiselect
                                        options={categories}
                                        avoidHighlightFirstOption={true}
                                        selectedValues={selectedCategories}
                                        onSelect={onSelectCategory}
                                        onRemove={onRemoveCategory}
                                        placeholder="Add Categories..."
                                        displayValue="name"
                                        // className='input_text'
                                        style={{
                                            chips: {
                                                background: '#004dc0'
                                            },
                                            searchBox: {
                                                'max-height': '70px',
                                                'min-height': '70px',
                                                'position': 'relative',
                                                'overflow-y': 'auto',
                                                'border': '1px solid #A4A4A4',
                                            }
                                        }}
                                    />
                                    <span className="errorMsg">{categoryErr}</span>
                                </FormGroup>
                                {showSubCategorySelect ?
                                    <FormGroup>
                                        <Label for="name">Sub Categories</Label>
                                        <Multiselect
                                            options={subCategoryList()}
                                            selectedValues={selectedSubCategories}
                                            onSelect={onSelectSubCategory}
                                            onRemove={onRemoveSubCategory}
                                            avoidHighlightFirstOption={true}
                                            placeholder="Add Sub Categories..."
                                            displayValue="name"
                                            // className='input_text'
                                            style={{
                                                chips: {
                                                    background: '#004dc0'
                                                },
                                                searchBox: {
                                                    'max-height': '70px',
                                                    'min-height': '70px',
                                                    'position': 'relative',
                                                    'overflow-y': 'auto',
                                                    'border': '1px solid #A4A4A4',
                                                }
                                                }}
                                            />
                                            <span className="errorMsg">{subCategoryErr}</span>
                                    </FormGroup> 
                                    : ''
                                }
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Input
                                            type="text"
                                            name="postal_code"
                                            value={postalCode}
                                            onChange={onChangeInput}
                                            placeholder="Postal Code"
                                            className="input_text"/>
                                            <span className="errorMsg">{postalCodeErr}
                                            {postalCodeErr == 'Invalid postal code!' ? 
                                                <GoogleModal handler={handler}/> : ''}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                    <Col md="6">
                                        <FormGroup>
                                            <Input
                                            type="text"
                                            name="phone_no"
                                            value={phoneNo}
                                            onChange={onChangeInput}
                                            placeholder="Phone"
                                            className="input_text"/>
                                            <span className="errorMsg">{phoneErr}</span>
                                        </FormGroup>
                                    </Col>                          
                                </Row>
                            </Form>
                            <div className="account_info_section">
                                <h3 className="signup_title">Account Info</h3>
                                <Form>
                                    <Row>
                                        <Col md="6">
                                            <FormGroup>
                                                <Input
                                                type="text"
                                                name="first_name"
                                                value={firstName}
                                                onChange={onChangeInput}
                                                placeholder="First Name"
                                                className="input_text"/>
                                                <span className="errorMsg">{firstNameErr}</span>
                                            </FormGroup>
                                        </Col>                
                                        <Col md="6">
                                            <FormGroup>
                                                <Input
                                                type="text"
                                                name="last_name"
                                                value={lastName}
                                                onChange={onChangeInput}
                                                placeholder="Last Name"
                                                className="input_text"/>
                                                <span className="errorMsg">{lastNameErr}</span>
                                            </FormGroup>
                                        </Col>                                           
                                    </Row>
                                    <FormGroup>
                                        <Input
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={onChangeInput}
                                        placeholder="Email"
                                        className="input_text"/>
                                        <span className="errorMsg">{emailErr}</span>
                                    </FormGroup>
                                    <span className="errorMsg">{otherError}</span>
                                    <Button
                                        onClick={submitHandler}
                                        className="primary-btn">
                                        <span>Next</span>
                                        {
                                            loading
                                            ? ( <span className="spinner-border spinner-border-sm ml-5" role="status" aria-hidden="true"> </span> )
                                            : ( <span></span> )
                                        }
                                    </Button>
                                </Form>
                            </div>
                            <p className="already_text">Already have an account? <Link href="/login"><a>Log in</a></Link> to continue</p>
                        </div>
                    </Col>
                    <Col lg="7" xl="8" md="6">
                        <div className="right_col_section">               
                            <h2 className="main-heading-lg">Sign Up As An Agency</h2>
                            <p className="description-text">Please fill in the details for an agency sign up.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export async function getServerSideProps({ req, res }) {
    let token = getCookie('token', { req, res});

    if(token != null) {
        try {
            const base64 = require('base-64');
            const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'user', { headers: {
                "Authorization" : 'Bearer '+ base64.decode(token),  "Accept": "application/json" }
            });

            const categories = await axios.get(process.env.NEXT_PUBLIC_API_URL + 'all_categories', { 
                headers: {"Accept": "application/json" }
            });

            const metaRes = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/', { headers: {
                "Accept": "application/json" }
            });

            const categoriesArr = categories.data.data.map(data => ({
                name:data.attributes.name, id:data.id
            }));
    
            return { props: { data: response.data, categories: categoriesArr, meta: metaRes.data.data } }

        } catch (err) {
            const data = false;
            const categories = false;
            const meta = false;

            return { props: { data, categories, meta } };
        }

    } else {
        const data = false;
        const categories = await axios.get(process.env.NEXT_PUBLIC_API_URL + 'all_categories', { 
            headers: {"Accept": "application/json" }
        });

        const metaRes = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/', { headers: {
            "Accept": "application/json" }
        });


        const categoriesArr = categories.data.data.map(data => ({
            name:data.attributes.name, id:data.id
        }));

        return { props: { data, categories: categoriesArr, meta: metaRes.data.data } };
    }
}

AgencySignup.Layout = PublicLayout;

export default AgencySignup

